import React, { Fragment } from "react";
import Navbar2 from "../../components/Navbar2";
import Hero3 from "../../components/hero3";
import Features from "../../components/Features";
import About from "../../components/about";
import Services2 from "../../components/Services2";
import Pricing from "../../components/Pricing";
import FunFact from "../../components/FunFact";
import Testimonial from "../../components/Testimonial";
import Support from "../../components/Support";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import { CarrosselLogosConsultoria } from "../../components/CarrosselLogosConsultoria";

const HomePageOld = () => {
  return (
    <Fragment>
      <Navbar2 />
      <Hero3 />
      <Features featuresClass="wpo-features-section-s2" />
      <h2 className="text-center fs-1 fw-bold mb-4">Alguns clientes atendidos</h2>
      <CarrosselLogosConsultoria />
      <About />
      <Services2 srvClass={"wpo-service-section-s3"} />
      <Pricing />
      <FunFact fnClass={"section-padding"} />
      <Support />
      <Testimonial />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default HomePageOld;
